import { PlatformLocation } from '@angular/common';
import { Component, Inject, Optional } from '@angular/core';
import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA} from '@angular/material/legacy-dialog';
import { MvdModalService } from '../../shared/services/modal/mvd-modal.service';
import { CustomerModalBaseComponent } from '../shared/customer-modal-base.component';

export class HistoricalCertificationContext {
    constructor(public customerNumberId: number) {}
}

@Component({
    templateUrl: './historical-customer-certification-modal.html'
})
export class HistoricalCustomerCertificationModalComponent extends CustomerModalBaseComponent {
    customerNumberId: number;

    constructor(public location: PlatformLocation,
        public dialogRef: MatDialogRef<HistoricalCustomerCertificationModalComponent>,
        @Optional() @Inject(MAT_DIALOG_DATA) public data: HistoricalCertificationContext,
        public modalService: MvdModalService) {
        super(modalService);

        this.customerNumberId = this.data.customerNumberId;

        location.onPopState(() => {
            this.dialogRef.close();
        });
    }

    ngOnInit() { }

    public cancel() {
        this.dialogRef.close();
    }
}
